export default "__VITE_ASSET__BCVc0o04__"